export const LOAD_INVITE = "LOAD_INVITE";
export const SET_INVITE = "SET_INVITE";